// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"Share_shareContainer__ejL7f","shareLinkWrapper":"Share_shareLinkWrapper__26Tyb","shareLink":"Share_shareLink__3uoyc"};